import {
  jb_secondary_menu_list_css_default
} from "./chunk.A4HBN3MX.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.JXPX63WS.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-secondary-menu-list/jb-secondary-menu-list.ts
var JbSecondaryMenuList = class extends Animatable(r) {
  constructor() {
    super(...arguments);
    this.activeIndex = 0;
  }
  _clearFocusedStateOnAll() {
    this.renderRoot.querySelectorAll("jb-menu-item").forEach((item) => {
      item.classList.remove("focus");
      item.classList.remove("active");
    });
  }
  _focusFirstMenuItem() {
    const menuItemToSelect = this.renderRoot.querySelector("jb-menu-item:not(.hidden)");
    menuItemToSelect.focus();
  }
  _handleFocus(evt) {
    this._clearFocusedStateOnAll();
    if (this.activeIndex !== parseInt(evt.target.dataset.index, 10)) {
      this.activeIndex = parseInt(evt.target.dataset.index, 10);
    }
    evt.target.classList.add("focus");
    evt.target.classList.add("active");
  }
  _handleFocusOut() {
    document.querySelector("jb-menu").shadowRoot.querySelector("jb-button-back")?.focus();
  }
  _removeFocus(evt) {
    evt.target.classList.remove("focus");
    evt.target.classList.remove("active");
  }
  _renderMenuItem(item, indx) {
    const link = { ...item.link };
    link.name = item.text;
    return ke`
      <p aria-hidden="true">${item.text}</p>
      <jb-menu-item
        .link=${link}
        .submenu=${item.submenu}
        .tag=${item.tag}
        .text=${item.text}
        role="listitem"
        .type=${"secondary"}
        .notTabbable=${this.activeIndex !== indx}
        data-index=${indx}
        class="${Rt({
      hidden: true
    })}"
        aria-label="${item.text}"
        @focus=${this._handleFocus}
        @focusout=${this._removeFocus}
      ></jb-menu-item>
    `;
  }
  render() {
    return ke`
      <div
        class="secondary-menu-list secondary"
        @focus=${this._focusFirstMenuItem}
        aria-label="${this.ariaLabels?.label || D}"
        role="list"
      >
        ${this.staticItem && ke` <jb-menu-item
          class="hidden"
          role="listitem"
          .link=${this.staticItem?.link}
          .text=${this.staticItem?.text}
          .type=${"secondary"}
        ></jb-menu-item>`}
        ${this.menuItems.map((item, indx) => this._renderMenuItem(item, indx))}
        <span
          class="last-item-focus-trap"
          @focusin=${this._handleFocusOut}
          tabindex="0"
          role="listitem"
          aria-hidden="true"
        >
          &nbsp;
        </span>
      </div>
    `;
  }
};
JbSecondaryMenuList.styles = [reset_css_default, jb_secondary_menu_list_css_default];
JbSecondaryMenuList.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Number })
], JbSecondaryMenuList.prototype, "activeIndex", 2);
__decorateClass([
  n({ type: Object })
], JbSecondaryMenuList.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Array })
], JbSecondaryMenuList.prototype, "menuItems", 2);
__decorateClass([
  n({ type: Object })
], JbSecondaryMenuList.prototype, "staticItem", 2);
JbSecondaryMenuList = __decorateClass([
  customElement("jb-secondary-menu-list")
], JbSecondaryMenuList);

export {
  JbSecondaryMenuList
};
